/* eslint-disable indent */
import React, { useEffect } from "react";
import styles from "../EditableTag.module.css";
import Seta from "../../../Assets/images/seta.png";
import { useEditableTag } from "./EditableTagBase";
import { ToolbarComponent, CanvasComponent } from "./SharedComponents";

const EditableTag12x5 = ({ initialData, doubleTag = false }) => {
	const canvasSize = { width: 340.15, height: 141.66 };
	const {
		canvasRef,
		elements,
		setElements,
		setInitialElements,
		selectedElement,
		setSelectedElement,
		zoom,
		handleMouseDown,
		handleElementClick,
		handleMouseMove,
		handleMouseUp,
		updateElementProperty,
		deleteElement,
		handleZoomIn,
		handleZoomOut,
		handleZoomReset,
		exportToPDF,
		printPDF,
		resetToInitialState
	} = useEditableTag(canvasSize);

	useEffect(() => {
		if (initialData)
			initializeElements(initialData);
	// eslint-disable-next-line react-hooks/exhaustive-deps
	}, [initialData]);

	const initializeElements = (data) => {
		const newElements = [];
		let idCounter = Date.now();

		// Layout 12x5 baseado em PdfHangTags12x5:
		// TOP: Logo (esquerda) + Cultura (centro) + QR Code + Barcode (direita, posição absoluta)
		// BOTTOM: Column layout vertical com todas as informações

		const topHeight = 40;

		// TOP CONTAINER
		// Logo area (esquerda)
		const logoX = 10;
		const logoWidth = 90;

		// Cultura/Título centralizado
		if (data.culture) {
			newElements.push({
				id: idCounter++,
				type: "text",
				content: data.culture,
				x: logoX + logoWidth + 10,
				y: 15,
				width: 140,
				height: 15,
				fontSize: 10,
				fontWeight: "bold",
				fontFamily: "Roboto, Arial, sans-serif",
				textAlign: "center",
				textTransform: "uppercase"
			});
		}

		// QR Code + Código de Barras na direita (posição absoluta, como no PDF)
		// marginTop: 105px no PDF original
		const rightSideX = 250;
		const qrCodeY = 35;

		// Textos acima do QR Code
		newElements.push({
			id: idCounter++,
			type: "text",
			content: "CONHEÇA ORIGEM",
			x: rightSideX,
			y: qrCodeY - 7,
			width: 80,
			height: 5,
			fontSize: 4,
			fontWeight: "bold",
			fontFamily: "Roboto, Arial, sans-serif",
			textAlign: "center",
			overflow: "visible"
		});

		newElements.push({
			id: idCounter++,
			type: "text",
			content: "DESTE PRODUTO",
			x: rightSideX,
			y: qrCodeY - 3,
			width: 80,
			height: 5,
			fontSize: 4,
			fontWeight: "bold",
			fontFamily: "Roboto, Arial, sans-serif",
			textAlign: "center",
			overflow: "visible"
		});

		// QR Code
		if (data.qrCode) {
			newElements.push({
				id: idCounter++,
				type: "image",
				content: data.qrCode,
				x: rightSideX + 12,
				y: qrCodeY,
				width: 55,
				height: 55
			});
		}

		// Código de Barras (abaixo do QR)
		if (data.barCode) {
			newElements.push({
				id: idCounter++,
				type: "image",
				content: data.barCode,
				x: rightSideX + 4,
				y: qrCodeY + 57,
				width: 72,
				height: 25,
				objectFit: "fill"
			});
		}

		// Texto "POR: SISAGRI"
		newElements.push({
			id: idCounter++,
			type: "text",
			content: "POR: SISAGRI",
			x: rightSideX,
			y: qrCodeY + 84,
			width: 80,
			height: 5,
			fontSize: 4,
			fontWeight: "bold",
			fontFamily: "Roboto, Arial, sans-serif",
			textAlign: "center",
			overflow: "visible"
		});

		// BOTTOM CONTAINER: Informações em column (vertical)
		const leftColumnX = 10;
		const leftColumnWidth = 230;
		let currentY = topHeight + 5;

		// Peso Líquido Mínimo (inline com valor destacado)
		if (data.weight) {
			newElements.push({
				id: idCounter++,
				type: "text",
				content: `Peso liquido Mínimo: ${data.weight}`,
				x: leftColumnX,
				y: currentY,
				width: leftColumnWidth,
				height: 12,
				fontSize: 8,
				fontWeight: "bold",
				fontFamily: "Roboto, Arial, sans-serif",
				textAlign: "left"
			});
			currentY += 10;
		}

		// Embalagem (se houver)
		if (data.packaging) {
			newElements.push({
				id: idCounter++,
				type: "text",
				content: `Embalagem: ${data.packaging}`,
				x: leftColumnX,
				y: currentY,
				width: leftColumnWidth,
				height: 10,
				fontSize: 8,
				fontWeight: "bold",
				fontFamily: "Roboto, Arial, sans-serif",
				textAlign: "left"
			});
			currentY += 10;
		}

		// Código de Rastreio
		if (data.trackingCode) {
			newElements.push({
				id: idCounter++,
				type: "text",
				content: `Código de Rastreio: ${data.trackingCode}`,
				x: leftColumnX,
				y: currentY,
				width: leftColumnWidth,
				height: 10,
				fontSize: 8,
				fontWeight: "bold",
				fontFamily: "Roboto, Arial, sans-serif",
				textAlign: "left"
			});
			currentY += 12;
		}

		// Produtor (3 linhas separadas)
		if (data.producer) {
			newElements.push({
				id: idCounter++,
				type: "text",
				content: `Distribuído por ${data.producer.name}`,
				x: leftColumnX,
				y: currentY,
				width: leftColumnWidth,
				height: 6,
				fontSize: 5,
				fontWeight: "normal",
				fontFamily: "Roboto, Arial, sans-serif",
				textAlign: "left"
			});
			currentY += 6;

			newElements.push({
				id: idCounter++,
				type: "text",
				content: data.producer.address,
				x: leftColumnX,
				y: currentY,
				width: leftColumnWidth,
				height: 6,
				fontSize: 5,
				fontWeight: "normal",
				fontFamily: "Roboto, Arial, sans-serif",
				textAlign: "left"
			});
			currentY += 6;

			newElements.push({
				id: idCounter++,
				type: "text",
				content: data.producer.document,
				x: leftColumnX,
				y: currentY,
				width: leftColumnWidth,
				height: 6,
				fontSize: 5,
				fontWeight: "normal",
				fontFamily: "Roboto, Arial, sans-serif",
				textAlign: "left"
			});
			currentY += 8;
		}

		// Distribuidor (3 linhas separadas)
		if (data.distributor) {
			newElements.push({
				id: idCounter++,
				type: "text",
				content: `Destino ${data.distributor.name}`,
				x: leftColumnX,
				y: currentY,
				width: leftColumnWidth,
				height: 6,
				fontSize: 5,
				fontWeight: "normal",
				fontFamily: "Roboto, Arial, sans-serif",
				textAlign: "left"
			});
			currentY += 6;

			newElements.push({
				id: idCounter++,
				type: "text",
				content: data.distributor.address,
				x: leftColumnX,
				y: currentY,
				width: leftColumnWidth,
				height: 6,
				fontSize: 5,
				fontWeight: "normal",
				fontFamily: "Roboto, Arial, sans-serif",
				textAlign: "left"
			});
			currentY += 6;

			newElements.push({
				id: idCounter++,
				type: "text",
				content: data.distributor.document,
				x: leftColumnX,
				y: currentY,
				width: leftColumnWidth,
				height: 6,
				fontSize: 5,
				fontWeight: "normal",
				fontFamily: "Roboto, Arial, sans-serif",
				textAlign: "left"
			});
			currentY += 8;
		}

		// Datas (cada uma em uma linha)
		if (data.dates) {
			if (data.dates.packaging) {
				newElements.push({
					id: idCounter++,
					type: "text",
					content: `Data de Embalagem: ${data.dates.packaging}`,
					x: leftColumnX,
					y: currentY,
					width: leftColumnWidth,
					height: 6,
					fontSize: 5,
					fontWeight: "normal",
					fontFamily: "Roboto, Arial, sans-serif",
					textAlign: "left"
				});
				currentY += 6;
			}

			if (data.dates.delivery) {
				newElements.push({
					id: idCounter++,
					type: "text",
					content: `Data de Entrega: ${data.dates.delivery}`,
					x: leftColumnX,
					y: currentY,
					width: leftColumnWidth,
					height: 6,
					fontSize: 5,
					fontWeight: "normal",
					fontFamily: "Roboto, Arial, sans-serif",
					textAlign: "left"
				});
				currentY += 6;
			}

			if (data.dates.expiry) {
				newElements.push({
					id: idCounter++,
					type: "text",
					content: `Data de Validade: ${data.dates.expiry}`,
					x: leftColumnX,
					y: currentY,
					width: leftColumnWidth,
					height: 6,
					fontSize: 5,
					fontWeight: "normal",
					fontFamily: "Roboto, Arial, sans-serif",
					textAlign: "left"
				});
				currentY += 6;
			}
		}

		// Especificação (se houver)
		if (data.specification) {
			newElements.push({
				id: idCounter++,
				type: "text",
				content: data.specification,
				x: leftColumnX,
				y: currentY,
				width: leftColumnWidth,
				height: 6,
				fontSize: 6,
				fontWeight: "bold",
				fontFamily: "Roboto, Arial, sans-serif",
				textAlign: "left"
			});
		}

		// Footer
		const footerY = 129;
		const footerHeight = 10;

		// Fundo preto do footer
		newElements.push({
			id: idCounter++,
			type: "footer-background",
			content: "",
			x: 0,
			y: footerY,
			width: canvasSize.width,
			height: footerHeight,
			backgroundColor: "black",
			isFooterElement: true,
			zIndex: -1
		});

		// Layout do footer
		const footerPadding = 6;
		const arrowWidth = 8;
		const spacing = 6;
		const totalArrows = 3 * arrowWidth;
		const totalSpacing = 4 * spacing;
		const availableForTexts = canvasSize.width - totalArrows - totalSpacing - (2 * footerPadding);
		const textWidth = availableForTexts / 2;

		let currentX = footerPadding;

		// Seta 1
		newElements.push({
			id: idCounter++,
			type: "image",
			content: Seta,
			x: currentX,
			y: footerY + 1,
			width: arrowWidth,
			height: 8,
			isFooterElement: true
		});
		currentX += arrowWidth + spacing;

		// Texto 1
		newElements.push({
			id: idCounter++,
			type: "text",
			content: "PRODUTO COM ORIGEM RASTREADA",
			x: currentX,
			y: footerY + 2,
			width: textWidth,
			height: 8,
			fontSize: 6,
			fontWeight: "bold",
			fontFamily: "Roboto, Arial, sans-serif",
			textAlign: "center",
			color: "white",
			lineHeight: 1.0,
			overflow: "visible",
			isFooterElement: true
		});
		currentX += textWidth + spacing;

		// Seta 2 (invertida)
		newElements.push({
			id: idCounter++,
			type: "image",
			content: Seta,
			x: currentX,
			y: footerY + 1,
			width: arrowWidth,
			height: 8,
			transform: "scaleX(-1)",
			isFooterElement: true
		});
		currentX += arrowWidth + spacing;

		// Texto 2
		newElements.push({
			id: idCounter++,
			type: "text",
			content: "https://www.sisagri.com.br",
			x: currentX,
			y: footerY + 2,
			width: textWidth,
			height: 8,
			fontSize: 6,
			fontWeight: "bold",
			fontFamily: "Roboto, Arial, sans-serif",
			textAlign: "center",
			color: "white",
			lineHeight: 1.0,
			overflow: "visible",
			isFooterElement: true
		});
		currentX += textWidth + spacing;

		// Seta 3 (invertida)
		newElements.push({
			id: idCounter++,
			type: "image",
			content: Seta,
			x: currentX,
			y: footerY + 1,
			width: arrowWidth,
			height: 8,
			transform: "scaleX(-1)",
			isFooterElement: true
		});

		setElements(newElements);
		setInitialElements(JSON.parse(JSON.stringify(newElements)));
	};

	const selectedElementData = elements.find(el => el.id === selectedElement);

	return (
		<div className={styles.editorContainer}>
			<ToolbarComponent
				selectedElementData={selectedElementData}
				updateElementProperty={updateElementProperty}
				handleZoomOut={handleZoomOut}
				handleZoomIn={handleZoomIn}
				handleZoomReset={handleZoomReset}
				zoom={zoom}
				exportToPDF={() => exportToPDF("12x5", doubleTag)}
				printPDF={() => printPDF(doubleTag)}
				resetToInitialState={resetToInitialState}
			/>

			<CanvasComponent
				canvasRef={canvasRef}
				canvasSize={canvasSize}
				zoom={zoom}
				elements={elements}
				selectedElement={selectedElement}
				setSelectedElement={setSelectedElement}
				handleMouseMove={handleMouseMove}
				handleMouseUp={handleMouseUp}
				handleMouseDown={handleMouseDown}
				handleElementClick={handleElementClick}
				deleteElement={deleteElement}
			/>
		</div>
	);
};

export default EditableTag12x5;
